@if (displayHelp && helpAlias) {
  <button mat-raised-button data-e2e="getting-started-show-help" (click)="showHelp()">
    <mat-icon svgIcon="help"></mat-icon>
    <span>{{ 'generic.getting_started' | translate}}</span>
  </button>
}
